import { render, staticRenderFns } from "./TableLimitSelector.vue?vue&type=template&id=358f7d86"
import script from "./TableLimitSelector.vue?vue&type=script&lang=js"
export * from "./TableLimitSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358f7d86')) {
      api.createRecord('358f7d86', component.options)
    } else {
      api.reload('358f7d86', component.options)
    }
    module.hot.accept("./TableLimitSelector.vue?vue&type=template&id=358f7d86", function () {
      api.rerender('358f7d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/TableLimitSelector.vue"
export default component.exports